module.exports = __webpack_public_path__ + "static/media/Burkina Faso.211cf4ca.png";